<template>
  <v-container class="pa-4">
    <v-layout
      v-if="!loading"
      class="d-flex column"
    >
      <v-card
        class="message-limit mb-4 pb-4"
        flat
      >
        <v-card-title class="message-limit__title mt-2 ml-2">
          <v-icon
            size="18px"
            color="black"
            class="mr-1"
          >
            mdi-alert-circle
          </v-icon>
          Fique atento, o limite de mensagens mudou!<br>
        </v-card-title>
        <v-card-text class="message-limit__text pa-0">
          {{ firstName }}, para evitarmos o seu bloqueio no
          WhatsApp por conta da nova política de envio de
          mensagens, <b>alteramos o limite
            para 50 mensagens por campanha a cada uma hora.</b><br>
          <br>
          Essa mudança é só temporária, tá? Assim que tivermos
          uma nova posição do WhatsApp, vamos te avisar e voltar
          ao limite original.
        </v-card-text>
      </v-card>
      <div class="text-center">
        <TitleChip title="Campanhas" />
      </div>
      <v-flex
        xs12
        text-xs-center
      >
        <v-layout
          row
          wrap
          class="justify-center"
          style="align-items: center"
        >
          <v-btn
            slot="activator"
            block
            color="primary"
            class="button mt-3 mb-4 contact-block-btn-text"
            style="align-items: center"
            @click="openBlockContacts"
          >
            <v-icon
              left
            >
              $vuetify.icons.blockIcon
            </v-icon>

            BLOQUEAR CONTATOS
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="!loading"
      row
      wrap
    >
      <span
        v-if="!activeCampaigns || activeCampaigns.length == 0"
        class="noCampaign animated fadeIn delay-1s"
      >
        Você não possui campanhas ativas
        <v-icon
          left
          color="#433D4E"
        >$vuetify.icons.winkIcon</v-icon>
      </span>
      <div class="marginToBottom">
        <v-layout
          v-if="activeCampaigns && activeCampaigns.length > 0"
          row
          wrap
          class="animated fadeIn delay-1s"
        >
          <v-spacer />
          <span class="hidden-sm-and-down text-xs-left grey--text">
            <v-switch
              v-model="appSwitch"
              color="#099AB1"
              label="Utilizar aplicativo desktop para envio de mensagens"
              @change="setApp"
            />
          </span>
          <v-flex
            v-for="campaign in activeCampaigns"
            :key="campaign.nome"
            xs12
            shrink
          >
            <CampanhaCard :campaign="campaign" />
          </v-flex>
        </v-layout>
      </div>
    </v-layout>
    <div
      v-if="loading && $auth.user"
      class="text-xs-center ma-2"
    >
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      />
    </div>
  </v-container>
</template>

<script>
/* eslint-disable max-len */

import { mapState } from 'vuex';
import CampanhaCard from '@/views/CampanhaCard.vue';
import { APIService } from '@/resources/campanha.js';
import { GetOrGenerateOptoutURLByCustomerId } from '@/apollo';

const api = new APIService();

export default {
  components: {
    CampanhaCard,
  },
  data() {
    return {
      counterSugerir: 0,
      loading: true,
      drawer: null,
      appSwitch: null,
      campaigns: [],
    };
  },
  computed: {
    activeCampaigns() {
      return this.campaigns.filter((el) => el.status === 'ACTIVE');
    },
    ...mapState(['customer']),
    firstName() {
      return this.$store.state.profile.name.split(' ')[0];
    },
  },
  watch: {
    async customer() {
      this.getOrGenerateOptoutURLByCustomerId();
    },
  },
  async mounted() {
    this.getCampaignsForSeller();
    this.appSwitch = JSON.parse(localStorage.getItem('USE_APP'));
    this.getOrGenerateOptoutURLByCustomerId();
  },
  methods: {
    async getOrGenerateOptoutURLByCustomerId() {
      const res = await this.$apollo.query({
        query: GetOrGenerateOptoutURLByCustomerId,
        variables: {
          customerId: this.customer.id,
        },
        fetchPolicy: 'no-cache',
      });
      console.log(res.data, res.data.getOrGenerateOptoutURLByCustomerId);
      this.optoutURL = res.data.getOrGenerateOptoutURLByCustomerId;
    },
    openBlockContacts() {
      if (this.optoutURL) window.open(`https://${this.optoutURL}`);
      else window.open('https://app.pipefy.com/public/form/mMBoRhPQ');
    },
    sendMessage() {
      this.counterSugerir += 1;

      this.$ga.event({
        eventCategory: 'Campanha',
        eventAction: 'Sugerir Campanha',
        eventValue: this.counterSugerir,
      });
      location.href = 'http://api.whatsapp.com/send?phone=5548991032835';
    },
    getCampaignsForSeller() {
      if (this.$auth.user) {
        return api.getCampaignsForSeller(this.$auth.user.sub).then((data) => {
          this.campaigns = data;
          this.loading = false;
        });
      }
      this.loading = false;
      return {};
    },
    setApp() {
      const USE_APP = JSON.parse(localStorage.getItem('USE_APP')) || false;
      localStorage.setItem('USE_APP', !USE_APP);
    },
  },
};
</script>

<style scoped lang="scss">
.noCampaign {
  font-size: 1.2em;
  margin: 0 auto;
  margin-top: 30px;
  padding: 16px;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}
.marginToBottom {
  width: 100%;
  margin-bottom: 175px;
}
.button {
  border-radius: 7px !important;
  height: 46px;
}
.contact-block-btn-text {
  font-family: 'neue-metana';
  font-style: normal;
  font-weight: normal;
  font-size: 12px !important;
}

.message-limit {
  width: 100%;
  border-radius: 7px;
  font-family: 'Nunito Sans';
  font-style: normal;
  line-height: 18px;
  background-color: #FFE7F6 !important;
  align-self: center !important;
  &__text {
    margin-left: 5%;
    width: 90%;
    color: #433D4E;
    font-weight: 600;
    font-size: 12px;
  }
  &__title {
    font-weight: 700;
    font-size: 12px;
  }
}

</style>
